import React from "react";
import LogoSVG from "@assets/logo/Logo.inline.svg";
import LogoDashedSVG from "@assets/logo/LogoDashed.inline.svg";
import "./Logo.scss";

const LogoComponent = ({ dashed }: boolean) => (
   <div className="logo-component">
      {dashed ? <LogoDashedSVG className="dashed" /> : <LogoSVG className="regular" />}
   </div>
);

export default LogoComponent;